










































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import moment from 'moment'
import { Geoloc } from "@/pitprojekt/models/Geoloc";
import GoogleMapDialog from "@/components/dialog/GoogleMapDialog.vue";
import { EventBus } from "@/pitprojekt/event-bus";


@Component({
    components: { GoogleMapDialog }
})
export default class TopBrowsersTableCard extends Vue {
  @Prop(String) title!: string
  @Prop(String) subtitle!: string
  @Prop(Object) data!: object
  @Prop(Boolean) isLoading!: boolean;
  @Prop(Boolean) isPageLoading!: boolean;
  @Prop(Number) total!: number;
  pagination: object = {};
  headers: object = [
            {
                text: 'Lok.',
                sortable: false,
            },
            {
                text: 'IP',
                sortable: false,
            },
            {
                text: 'Miejscowość',
                sortable: false,
            },
            {
                text: 'Ilość',
                sortable: false,
                value: 'count'
            }
        ];

  @Watch('pagination')
  onPagination() {
    this.$emit('loadData', this.pagination);
  }

    tooltipGeolocIcon(geoloc: Geoloc): string {
        let formattedTooltip: string = '';
        if ( geoloc.country && geoloc.country != undefined && geoloc.country != 'Unknown') formattedTooltip += geoloc.country + ' (' + geoloc.iso_code + ')';
        if ( geoloc.city && geoloc.city != undefined && geoloc.city != 'Unknown') formattedTooltip += ', ' + geoloc.city;
        if ( geoloc.state_name && geoloc.state_name != undefined && geoloc.state_name != 'Unknown') formattedTooltip += ', ' + geoloc.state_name + '(' + geoloc.state + ')';
        if ( geoloc.postal_code && geoloc.postal_code != undefined && geoloc.postal_code != 'Unknown') formattedTooltip += ', ' + geoloc.postal_code;
        return formattedTooltip;
    }

    showGoogleMapDialog(geoloc: Geoloc) {
      EventBus.$emit('showGoogleMapDialogEvent', geoloc);
    }


}
